import CustomerProjectSelector from "./CustomerProjectSelector";

export default CustomerProjectSelector;
